<!-- For empty Announcement -->
<div class="container-fluid" *ngIf="emptyAnnouncement">
    <div class="row">
        <p class="text-center">{{message}}</p>
    </div>
</div>
<!--  -->

<!-- Spinner -->
<div align="center" *ngIf="spinner" class="mt-3">
    <mat-spinner [diameter]="30"></mat-spinner>
</div>
<!--  -->

<!-- For displaying Announcement -->
<div class="container-fluid" *ngIf="!emptyAnnouncement" style="height: 50vh; max-height: 50vh; overflow: auto;">
    <div class="row" *ngFor="let announcement of announcementArray">
        <div class="col-12">
            <div class="d-flex">
                <div>
                    <mat-icon class="mr-3 mt-2" style="font-size: 25pt;">account_circle_full</mat-icon>  
                </div>
                <div>
                    <span>{{announcement.firstname}} {{announcement.lastname}}</span><br>
                    <span style="font-size: 9pt;">{{announcement.created_at}}</span>
                </div>
            </div>
            <div>
                <h6>{{announcement.title}}</h6>
                <p [innerHTML]="announcement.details"></p>
            </div>
            <hr>
        </div>
    </div>
</div>
<!--  -->